import { withStyles } from "@material-ui/core";
import { Collection, Model } from "@type-r/models";
import { Linked, useLinked } from "@type-r/react";
import * as React from 'react';
import Select, { components } from "react-select";
import AsyncSelect from 'react-select/async';
import { LxInputProps } from ".";

export interface SelectMultiProps extends LxInputProps<any> {
  classes?: any,
  $selected?: Linked<any>,
  options: any,
  onMenuClosed?
}

export const SelectMulti = withStyles({
})(
  ({ classes, options, $selected, onMenuClosed }: SelectMultiProps) => {

    const $selection = useLinked([]);
    const [inputValue, setInputValue] = React.useState("");

    const filteredOptions = React.useMemo(() => {
      if (!inputValue) {
        return options.slice(0, 100);
      }
      const inputValueLower = inputValue.toLowerCase();
      return options.filter(x => x.toLowerCase().indexOf(inputValueLower) >= 0).slice(0, 100);
    }, [inputValue]);

    const selectChangeHandler = (event, action) => {
      if (action.action === 'select-option' || action.action === 'deselect-option') {
        $selection.set(event);
        $selected.set(event.map(ev => ev.value));
      }
    }

    return (
      <Select components={{ Option, ClearIndicator }}
        filterOption={() => true}
        hideSelectedOptions={false}
        isMulti styles={customStyles}
        className={classes.selectionBox}
        onInputChange={(value) => setInputValue(value)}
        options={filteredOptions.map(opt => { return { label: opt, value: opt } })}
        placeholder={'Select'}
        value={$selection && $selection.value}
        onChange={(event, action) => selectChangeHandler(event, action)}
        onMenuClose={onMenuClosed}
        closeMenuOnSelect={false}
      />
    );
  }
);

export const SelectMultiEx = withStyles({
})(
  ({ classes, options, selected, label = (x: any) => x.label, placeholder, autocomplete }: {
    classes: any,
    options: Collection,
    selected: Collection,
    label?: (x: Model) => React.ReactNode,
    placeholder?: string,
    autocomplete?: boolean
  }) => {
    const selectOptions = React.useMemo(() => options.map(opt => ({ label: label(opt), value: opt.id })), [options['_changeToken']]);

    const selectChangeHandler = (event, action) => {
      if (action.action === 'select-option' || action.action === 'deselect-option') {
        selected.set(event.map(ev => options.get(ev.value)));
      }
      if (action.action === 'clear') {
        selected.reset();
      }
    };

    const getPrependedSelectedOptions = (options: { label: React.ReactNode, value: string }[]): any[] => {
      return selected.map(x => ({ label: label(x), value: x.id })).concat(options.filter(x => !selected.some(y => y.id === x.value)).slice(0, 50));
    };

    const loadOptions = (inputValue: string) =>
      new Promise(resolve => {
        const trimmedValue = inputValue.trim();
        if (!trimmedValue) {
          resolve(getPrependedSelectedOptions(selectOptions));
        } else {
          const regex = new RegExp(`^(${trimmedValue})`, 'i');
          resolve(getPrependedSelectedOptions(selectOptions.filter(x => regex.test(x.label as string))));
        }
      });

    const commonProps = {
      components: { Option, ClearIndicator: autocomplete ? getAutocompleteClearIndicator(selectOptions.length) : ClearIndicator },
      isMulti: true,
      styles: customStyles,
      className: classes.selectionBox,
      hideSelectedOptions: false,
      placeholder: placeholder || 'Select',
      value: selected.map(x => ({ label: label(x), value: x.id })),
      onChange: (event, action) => selectChangeHandler(event, action),
      closeMenuOnSelect: false,
    };

    return autocomplete
      ? (
        <AsyncSelect
          {...commonProps}
          defaultOptions={getPrependedSelectedOptions(selectOptions)}
          loadOptions={loadOptions}
        />
      ) : (
        <Select
          {...commonProps}
          options={selectOptions}
        />
      );
  }
);

const customStyles = {
  multiValue: (provided) => ({
    display: 'none'
  }),
  valueContainer: (provided) => ({
    ...provided,
    width: '200px',
    height: '40px',
    overflowX: 'hidden',
    overflowY: 'auto',
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: '0px'
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '5px'
  }),
  option: (provided) => ({
    backgroundColor: 'red',
    fontSize: 10
  }),
}

const Option = props => {
  return (<div>
    <components.Option {...props}>
      <div style={{ float: 'left' }}>
        <input style={{ margin: '5px' }} type="checkbox" checked={props.isSelected} onChange={() => null} />
        <label style={{ margin: '5px', width: '180px', textAlign: 'left' }} >{props.label}</label>
      </div>
    </components.Option>
  </div>);
};

const ClearIndicator = props => {
  const selectedCount = props.selectProps.value["length"];
  return (<div>
    <components.ClearIndicator {...props}>
      <div style={{ marginLeft: '5px', float: 'left', color: 'green' }}>Clear {props.selectProps.placeholder}
        <span> {selectedCount}/{props.totalOptions || props.options.length}</span>
      </div>
    </components.ClearIndicator>
  </div>);
};


const getAutocompleteClearIndicator = (totalOptions: number) => {
  return props => (<ClearIndicator totalOptions={totalOptions} {...props} />);
};